module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPHBhdGggZmlsbD0iIzA3ODkzMCIgZD0iTTAgMGg2NDB2NDgweiIvPgogIDxwYXRoIGZpbGw9IiNmY2RkMDkiIGQ9Ik0wIDBsNjQwIDQ4MEgweiIvPgogIDxwYXRoIGZpbGw9IiNkYTEyMWEiIGQ9Ik0yNTIuMzcgMjE4LjAyNWgxMzUuMjZMMjc4LjIwMyAyOTcuNTMgMzIwIDE2OC44OWw0MS43OTggMTI4LjY0eiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/gf.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/gf.svg
// module chunks = 0